import { useEffect, useState } from "react";
import "../css/OrientationWarning.css"; // archivo css aparte

export function OrientationWarning() {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;
      const isMobile = window.innerWidth <= 768; // considerar mobile hasta 768px
      setShowWarning(isMobile && isPortrait);
    };

    checkOrientation();

    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
    };
  }, []);

  if (!showWarning) return null;

  return (
    <div className="orientation-overlay">
      <div className="orientation-box">
        <h2>⚠️ Gira tu dispositivo</h2>
        <p>Para una mejor experiencia, usa la aplicación en modo horizontal (landscape).</p>
      </div>
    </div>
  );
}
